/**
 * Сортирует массив элементов таблицы по указанному полю
 * @param {Array} items - массив элементов для сортировки
 * @param {Object} sortData - объект с данными сортировки
 * @param {string} sortData.name - имя поля для сортировки
 * @param {boolean} sortData.sortDesc - направление сортировки
 * @returns {Array} отсортированный массив
 */
function sortTableItems (items, sortData) {
  const { name, sortDesc } = sortData

  return [...items].sort((a, b) => {
    let aValue = a[name]
    let bValue = b[name]

    // Обработка вложенных объектов (например, 'order.account_number')
    if (name.includes('.')) {
      const keys = name.split('.')
      aValue = keys.reduce((obj, key) => obj?.[key], a)
      bValue = keys.reduce((obj, key) => obj?.[key], b)
    }

    // Преобразование в числа для числовых полей
    const numericFields = [
      'value', 'position_value', 'time_at_wait', 'time_at_wait_by_one',
      'time_at_work', 'time_at_work_by_one',
      'time_total', 'time_total_by_one'
    ]

    if (numericFields.includes(name)) {
      aValue = parseFloat(aValue) || 0
      bValue = parseFloat(bValue) || 0
    }

    // Сортировка строк
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      aValue = aValue.toLowerCase()
      bValue = bValue.toLowerCase()
    }

    // Обработка null/undefined значений
    if (aValue == null && bValue == null) return 0
    if (aValue == null) return sortDesc ? -1 : 1
    if (bValue == null) return sortDesc ? 1 : -1

    // Сравнение значений
    if (aValue < bValue) return sortDesc ? 1 : -1
    if (aValue > bValue) return sortDesc ? -1 : 1
    return 0
  })
}

/**
 * Обновляет состояние сортировки в колонках (включая columnsBefore)
 * @param {Array} columnsBefore - массив колонок в заголовке (если есть)
 * @param {Array} columns - массив основных колонок
 * @param {string} sortedColumnName - имя отсортированной колонки
 * @param {boolean} sortDesc - направление сортировки
 * @returns {Object} объект с обновленными массивами колонок
 */
function updateColumnSortState (columnsBefore = [], columns, sortedColumnName, sortDesc) {
  const updateColumns = (cols) => {
    return cols.map(col => ({
      ...col,
      sortDesc: col.name === sortedColumnName ? sortDesc : true
    }))
  }

  return {
    columnsBefore: columnsBefore ? updateColumns(columnsBefore) : [],
    columns: updateColumns(columns)
  }
}

export {
  sortTableItems,
  updateColumnSortState
}
